import {React} from '@api';
import {Icon} from '@blueprintjs/core';
import * as css from './ToggleInfoPanelButton.css';
import {PrimaryIconButton} from 'centric-ui-components';

export const ToggleInfoPanelButton : React.FC<{
  toggleInfoPanel: () => void
  infoPanelActive: boolean
}> = ({toggleInfoPanel, infoPanelActive}) => {
  return null
  // return <PrimaryIconButton className={css.infoPanelButton} icon={<Icon iconSize={14} icon='info-sign'/>} active={infoPanelActive} onClick={toggleInfoPanel}/>
}


// WEBPACK FOOTER //
// ./src/modules/common/components/InfoCards/ToggleInfoPanelButton.tsx